// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import { PlatformStatuses } from '@shared/constants/platform';

interface PlatformItemDTO {
  id: number;
  name: string;
}

export type GPSProvider = PlatformItemDTO
export type DroneManufacturer = PlatformItemDTO
export type DroneModel = PlatformItemDTO

export type CameraItem = PlatformItemDTO;
export type CameraName = PlatformItemDTO['name'];
export type Camera = CameraItem | CameraName;

export type GimbalItem = PlatformItemDTO;
export type GimbalName = PlatformItemDTO['name'];
export type Gimbal = GimbalItem | GimbalName;

export type LenseItem = PlatformItemDTO;
export type LenseName = PlatformItemDTO['name'];
export type Lense = LenseItem | LenseName;

interface PayloadHardware {
  cameras: Array<Camera>;
  gimbals: Array<Gimbal>;
  gimbalBattery: string;
  lenses: Array<Lense>;
  gpsProvider: GPSProvider;
}

interface PayloadSoftware {
  version: string;
  installDate: string;
}

interface Drone {
  modelId: number;
  manufacturerId: number;
  manufacturerName: string;
  modelName: string;
  name: string; // TODO same as modelName
  serialNumber: string;
  batteriesCount: number;
  controllerName: string;
  maxFlightTime: string;
}

export interface PlatformDTO {
  id: number;
  companyId: number;
  serialNumber: string;
  status: PlatformStatuses;
  drone: Drone;
  payloadHardware: PayloadHardware;
  payloadSoftware: PayloadSoftware;
  isBlocked?: boolean;
  isActive?: boolean;
  platformOwnerShip?: string;
}

export default class Platform {
  id: number;
  companyId: number;
  serialNumber: string;
  platformStatus: string;
  status: PlatformStatuses;
  drone: Drone;
  payloadHardware: PayloadHardware;
  payloadSoftware: PayloadSoftware;
  isBlocked: boolean;
  isActive: boolean;
  platformOwnerShip?: string;

  constructor(dto: PlatformDTO) {
    this.update(dto);
  }

  get asJson(): PlatformDTO {
    return {
      id: this.id,
      companyId: this.companyId,
      serialNumber: this.serialNumber,
      status: this.status,
      drone: this.drone,
      payloadHardware: this.payloadHardware,
      payloadSoftware: this.payloadSoftware,
      isBlocked: this.isBlocked,
      isActive: this.isActive,
      platformOwnerShip: this.platformOwnerShip,
    };
  }

  update(newData: Partial<PlatformDTO>): PlatformDTO {
    const allData = { ...this.asJson, ...newData };

    Object.assign(this, allData);

    this.platformOwnerShip = 'Visual Intelligence';

    return this.asJson;
  }
}
